export default __webpack_public_path__ + "static/media/purple_macaroon.79e8b4c1.png";